// React
import React, { Component } from 'react';
import {ButtonGroup, Tooltip} from '@material-ui/core/';
import {functions} from 'constants/index';
import {Description, CheckCircleOutline, Block, RestorePage, Add, GetApp} from '@material-ui/icons/';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux

import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import BotonElement from 'components/BotonTable'; 
import Footer from 'pages/Home/Footer2';
import CrearSolicitud from './AutorizarSolicitudesEmpadronamiento';
import RechazarSolicitud from './RechazarSolicitudEmpadronamiento'
import ProcesarSolicitudDelPortalWebTSE from './ProcesarSolicitudesPortalWebExterno/index';
import LoadingSpinner from 'components/LoadingSpinner';
import DescargarConstanciaEmpadronamiento from './DescargarConstanciaEmpadronamiento'

// import NewCensusRegistration from './newCensusRegistration';
import SolicitudesEmpadronamiento from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento'
import SolicitudesExtranjero from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/datosCiudadanosExtranjero'
import {showMessageErrorSimple, showMessageError, showMessagePersonalizedPosition} from 'services/SweetAlert'
import MostrarPDFModal from 'components/PdfModal'
import { Alert } from '@material-ui/lab';
import ComponenteToolbar from './ComponenteToolbar'
import ModalInformation from 'components/ModalToTableInformation';

class SolicitudesNuevas extends Component {
    constructor(props) {
        super(props);
        let paginacionTable = {}
        let pageSize=[]
        this.state = {
            datosSolicitudGeneradoNancional: props.datosSolicitudGeneradoNancional,
            SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP: props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP,
            SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD: props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD,
            // SET_DIALOGO_STATUS: props.SET_DIALOGO_STATUS,
            dialogoStatus: props.dialogoStatus,
            esRechazadoOEmpadronado: props.esRechazadoOEmpadronado,
            datosGeneralesDelCiudadano: props.datosGeneralesDelCiudadano,
            controller:'solicitudesDeEmpadronamiento',
            loading: false,
            loadingCargarFotosDeIdentidad:false,
            authorized:true,
            checkAutorization:false,
            aceptarOpen: false,
            rechazarOpen: false,
            newCve:"",
            abrirModalAceptarSolicitud: false,
            accionDeProceso:'', isNacional:'',
            abrirModalRechazoSolicitud: false,
            modalProcesarSolicitudExtranjero: false,
            abrirModalSolicitudDelPortalWebTSE: false,
            datosPadron:{},
            rowData: [],
            data: [],
            cuiDPI:'',
            customActions:[],
            TableData: [],
            idSolicitudObtenido:'',
            header: [
                { title: 'Solicitud TSE No.', field: 'datosSolicitudEmpadronamiento.idSolicitud',cellStyle:{ maxWidth: '80px' } },
                // { title: 'Solicitud RENAP No.', field: 'datosDpiSolicitudEmpadronamiento.complementoDpiSolicitud.nroSolicitudRenap' },
                { title: 'Nombre Completo', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }, filtering: false},
                { title: 'CUI', field: 'datosDpiSolicitudEmpadronamiento.cui' },
                { title: 'Pais Residencia', field: 'datosSolicitudEmpadronamiento.descripcionPaisResidencia.nombrePaisCorto' },
                { title: 'Estado Residencia', field: 'datosSolicitudEmpadronamiento.nombreDelEstado'},
                { title: 'Ciudad Residencia', field: 'datosSolicitudEmpadronamiento.nombreDelaCiudad',},
                { title: 'Departamento Residencia', field: 'departamentoResidencia.name'},
                { title: 'Municipio Residencia', field: 'municipioResidencia.name',},
                { title: 'Fecha de solicitud', field: 'datosSolicitudEmpadronamiento.fechaParseada',filtering: false},
                // { title: 'Fecha de solicitud', field: 'datosSolicitudEmpadronamiento.fechaSolicitud', render: (rowData) => functions.splitDate(rowData.datosSolicitudEmpadronamiento?.fechaSolicitud)},
                { title: 'Fecha modificó', field: 'datosSolicitudEmpadronamiento.fechaFueCreada', filtering: false},
                { title: 'Hora modificó', field: 'datosSolicitudEmpadronamiento.horaFueCreada', filtering: false},                
                { title: 'Usuario modificó', field: 'datosSolicitudEmpadronamiento.usuarioCreo', },
                { title: 'Origen', field: 'datosSolicitudEmpadronamiento.tipoOrigen'},
                { title: 'Tipo Solicitud', field: 'datosSolicitudEmpadronamiento.tipoSolicitud',},                
                { title: 'Nacional / Extranjero', field: 'datosSolicitudEmpadronamiento.nacionalExtranjero', filtering: false},
                // { title: 'Estado Procesada', field: 'datosSolicitudEmpadronamiento.estadoDeFiltrado', 
                //     render: (rowData) => (
                //     <div style={{ minWidth: "200px" }}>
                //         {
                //         (rowData.datosSolicitudEmpadronamiento.nacionalExtranjero === 'EXTRANJERO') ? (
                //             (rowData.datosSolicitudEmpadronamiento.estadoDeFiltrado === 1 && rowData.datosSolicitudEmpadronamiento.statusSolicitud === 0) ? 
                //                 <div>
                //                     <Tooltip title="Está en proceso de validación" aria-label="Está en proceso de validación">                                        
                //                         <Block />
                //                     </Tooltip>
                //                 </div>
                //             : (rowData.datosSolicitudEmpadronamiento.estadoDeFiltrado === 2 && rowData.datosSolicitudEmpadronamiento.statusSolicitud === 0) ? 
                //                 <div>
                //                     <Tooltip title="Listo para Procesar" aria-label="Listo para Procesar">                                        
                //                         <CheckCircleOutline style={{color: 'green'}}/>
                //                     </Tooltip>
                //                 </div> : '' 
                //             ):''
                //         }
                //     </div>
                // )},
                { title: 'Acción', field: 'accion', filtering: false,
                    render: rowData=><div>
                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                        {(rowData.datosSolicitudEmpadronamiento.nombreOrigen === 1) ? 
                            (rowData.datosSolicitudEmpadronamiento.esNacional === false) ? (
                                // (rowData.datosSolicitudEmpadronamiento.estadoDeFiltrado === 1 && rowData.datosSolicitudEmpadronamiento.statusSolicitud === 0) ? ''
                                // : (rowData.datosSolicitudEmpadronamiento.estadoDeFiltrado === 2 && rowData.datosSolicitudEmpadronamiento.statusSolicitud === 0) ?
                                // :''
                                <BotonElement icon={<Description />} title="Procesar Solicitud Extranjero" function={() => this.AbrirModalProcesarSolicitudExtranjero(rowData)}/>
                            ) : <BotonElement icon={<Description />} title="Procesar Solicitud Nacional" function={() => this.AbrirModalProcesarSolicitudPortalWebExterno(rowData)}/>
                        : (rowData.datosSolicitudEmpadronamiento.nombreOrigen === 2) ? (
                            <>
                                <BotonElement icon={<Description />} title="Hoja de Autorización" function={() => this.AbrirMostrarPDFModal(rowData)}/>
                                <BotonElement icon={<Description />} title="Procesar Solicitud RENAP" function={() => this.AbrirModalAprobarSolicitudEmpadronamientoModal(rowData)}/>
                            </>
                        )
                        : (rowData.datosSolicitudEmpadronamiento.nombreOrigen === 3) ? 
                            <BotonElement icon={<Description />} title="Procesar Solicitud Delegación" function={() => this.AbrirModalProcesarSolicitudExtranjero(rowData)}/>
                        :''
                        }                        
                    </ButtonGroup>                            
                    </div>            
                }, 
            ],
            currentUser: props.currentUser,
            datosIdentidad: [
                { tipo:'Fotografía', nombreCompleto:'', nombreCompletoPrueba:'', primerNombre:'', segundoNombre:'', primerApellido:'', segundoApellido:'', tercerApellido:'', foto: '', fechaNacimiento: '', width: 480, height: 640},
                { tipo:'Firma', foto: '', width: 300, height: 100},
                { tipo:'Huella', foto: '', width: 416, height: 416},
            ],
            fotosVieneVacio:false,
            mensajeFotosVieneVacio:'',
            datosEmpadronador:{},
            showModalNewCensusRegistration: false,
            datosSolicitudExtranjero: {},
            estaEmpadronado: false, nroBoleta: '',
            abrirMostrarPDFModal: false, base64PDFHojaAutorizacionRenap:'',
            datosSolicitudRenapExtranjero: [],
            datosResidenciaExtranjeroRenapSeleccionado:'',
            arrayMenuDesplegable:[],
            openDialogInstruction:false,
            // homonimos
            arrayHomonimos: []
        }
    //declaraciones de todas las funciones que se utilizaran
        this.showList = this.showList.bind(this);   
        this.AbrirModalAprobarSolicitudEmpadronamientoModal = this.AbrirModalAprobarSolicitudEmpadronamientoModal.bind(this);
        this.AbrirModalProcesarSolicitudPortalWebExterno = this.AbrirModalProcesarSolicitudPortalWebExterno.bind(this);
        this.CerrarModalProcesarSolicitudPortalWebExterno = this.CerrarModalProcesarSolicitudPortalWebExterno.bind(this);
        this.AbrirModalProcesarSolicitudExtranjero = this.AbrirModalProcesarSolicitudExtranjero.bind(this);
        this.CerrarModalSolicitudEmpadronamientoModal = this.CerrarModalSolicitudEmpadronamientoModal.bind(this);
        this.CerrarModalProcesarSolicitudExtranjero = this.CerrarModalProcesarSolicitudExtranjero.bind(this);
        
        this.AbrirModalRechazarSolicitudEmpadronamientoModa = this.AbrirModalRechazarSolicitudEmpadronamientoModa.bind(this);
        this.CerrarModalRechazoDeSolicitudEmpadronamientoModal = this.CerrarModalRechazoDeSolicitudEmpadronamientoModal.bind(this);
        this.ObtenerDatosEmpadronador = this.ObtenerDatosEmpadronador.bind(this);
        this.openModalForNewCensusRegistration = this.openModalForNewCensusRegistration.bind(this);
        this.closeModalForNewCensusRegistration = this.closeModalForNewCensusRegistration.bind(this);
        
        this.getUserState = this.getUserState.bind(this);
        // this.obtenerDatosDeLaTabla = this.obtenerDatosDeLaTabla.bind(this);
        this.obtenerPaginacionTabla = this.obtenerPaginacionTabla.bind(this);
        this.descargarReporteSolicitudesNuevas = this.descargarReporteSolicitudesNuevas.bind(this);
        this.AbrirMostrarPDFModal = this.AbrirMostrarPDFModal.bind(this);
        this.CerrarMostrarPDFModal = this.CerrarMostrarPDFModal.bind(this);
        this.FuncionObtenerDatosGeneralesDeLaTabla = this.FuncionObtenerDatosGeneralesDeLaTabla.bind(this);
        this.FuncionObtenerRegistroDeLaSolicitudDeRenapExtranjero = this.FuncionObtenerRegistroDeLaSolicitudDeRenapExtranjero.bind(this);
        this.mostrarInstruccion = this.mostrarInstruccion.bind(this);
        this.cerrarMostrarInstruccion = this.cerrarMostrarInstruccion.bind(this);
    }
    // obtenemos datos generales de la tabla
        FuncionObtenerDatosGeneralesDeLaTabla (data) {
            if(data){
                this.setState({datosSolicitudRenapExtranjero: data?.dataComplementoRenap})
            }
            return;
        }
        FuncionObtenerRegistroDeLaSolicitudDeRenapExtranjero (registroSeleccionado) {      
            if(this.state.datosSolicitudRenapExtranjero?.length>0){
                for (let index = 0; index < this.state.datosSolicitudRenapExtranjero.length; index++) {
                    if(this.state.datosSolicitudRenapExtranjero[index].idSolicitud === registroSeleccionado.idSolicitud){
                        this.setState({datosResidenciaExtranjeroRenapSeleccionado: this.state.datosSolicitudRenapExtranjero[index] })
                        break;
                    }else{
                        this.setState({datosResidenciaExtranjeroRenapSeleccionado:'' })
                    }
                }
            }      
        }
    //obtenemos los datos del empadronador para mostrarlo en pantalla
    async ObtenerDatosEmpadronador(){
        try{
            let response = await ApiServices.solicitudesDeEmpadronamiento.usuariosGeo();
            if(response.error){
                showMessagePersonalizedPosition('warning','¡Advertencia!', response?.error?.message,'center')
            }else {
                var datos = response.data
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_EMPADRONADOR(datos)
            } 
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
        }                
    }
    //abrimos el modal para aprobar solicitudes de empadronamiento
        async AbrirModalAprobarSolicitudEmpadronamientoModal(data){ 
            this.FuncionObtenerRegistroDeLaSolicitudDeRenapExtranjero(data)
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_RESIDENCIA_ELECTORAL_ACTUAL({})
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            if(data.datosDpiSolicitudEmpadronamiento === null){
                showMessageErrorSimple('¡Oops!','Solicitud # '+data.datosSolicitudEmpadronamiento.idSolicitud+' no cuenta con CUI de DPI.')
            }else{
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI(data.datosDpiSolicitudEmpadronamiento.cui) 
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD([])                
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP(data.datosSolicitudEmpadronamiento.idSolicitud)
                let userData = {
                    municipioNacimiento: {value: data.datosDpiSolicitudEmpadronamiento.municipioNacimieno},
                    departamentoNacimiento: {value: data.datosDpiSolicitudEmpadronamiento.departamentoNacimiento},
                    fechaNacimiento: {value: data.fechaNacimiento},
                    primerNombre: {value: data.primerNombre}, 
                    segundoNombre: {value: data.segundoNombre}, 
                    primerApellido: {value: data.primerApellido},
                    segundoApellido: {value: data.segundoApellido},
                    cui: {value: data.datosDpiSolicitudEmpadronamiento.cui},
                    ordenCedula: {value: data.datosDpiSolicitudEmpadronamiento.ordenDeNumeracionCedula},
                    registroCedula: {value: data.datosDpiSolicitudEmpadronamiento.numeroDeLaCedula},
                    // cedula: {value: data.datosDpiSolicitudEmpadronamiento.registroCedulaRef },
                    // genero: {value: (data.genero === 1) ? 'Masculino' : 'Femenino'},
                }
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_HOMONIMOS(userData);
                // this.props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI(3280804031101)            
                // this.props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
                this.setState({loadingCargarFotosDeIdentidad: true})
                try{
                    this.props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(0);    
                    const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosDpiSolicitudEmpadronamiento.cui);
                    // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('1997885610101');
                    // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('2937443351101');
                    if(response.error!==null){
                        if(data.primerNombre === null) this.state.datosIdentidad[0].primerNombre = "";
                        else this.state.datosIdentidad[0].primerNombre = data.primerNombre;
        
                        if(data.segundoNombre === null) this.state.datosIdentidad[0].segundoNombre = "";
                        else this.state.datosIdentidad[0].segundoNombre = data.segundoNombre;
        
                        if(data.primerApellido === null) this.state.datosIdentidad[0].primerApellido = "";
                        else this.state.datosIdentidad[0].primerApellido = data.primerApellido;
        
                        if(data.segundoApellido === null) this.state.datosIdentidad[0].segundoApellido = "";
                        else this.state.datosIdentidad[0].segundoApellido = data.segundoApellido;
        
                        if(data.tercerApellido === null) this.state.datosIdentidad[0].tercerApellido = "";
                        else this.state.datosIdentidad[0].tercerApellido = data.tercerApellido;                
                        // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('3280804031101');
                        this.state.datosIdentidad[0].nombreCompletoPrueba = this.state.datosIdentidad[0].primerNombre+' '+ this.state.datosIdentidad[0].segundoNombre+', '+ this.state.datosIdentidad[0].primerApellido+' '+ this.state.datosIdentidad[0].segundoApellido+', '+this.state.datosIdentidad[0].tercerApellido
                        this.state.datosIdentidad[0].nombreCompleto = data.primerNombre+' '+ data.segundoNombre+', '+ data.primerApellido+' '+ data.segundoApellido+', '+data.tercerApellido
                        this.state.datosIdentidad[0].fechaNacimiento = data.fechaNacimiento
    
                        this.state.datosIdentidad[0].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[0].width = 300; this.state.datosIdentidad[0].height = 400
                        this.state.datosIdentidad[1].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[1].width = 300; this.state.datosIdentidad[1].height = 400
                        this.state.datosIdentidad[2].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[2].width = 300; this.state.datosIdentidad[2].height = 400
                        this.setState({fotosVieneVacio: true, mensajeFotosVieneVacio: response.error.message, loadingCargarFotosDeIdentidad:false,});                    
                        // showMessageErrorSimple('Oops!', response.error.message)
                    }else{                                       
                        if(data.primerNombre === null) this.state.datosIdentidad[0].primerNombre = "";
                        else this.state.datosIdentidad[0].primerNombre = data.primerNombre;
    
                        if(data.segundoNombre === null) this.state.datosIdentidad[0].segundoNombre = "";
                        else this.state.datosIdentidad[0].segundoNombre = data.segundoNombre;
    
                        if(data.primerApellido === null) this.state.datosIdentidad[0].primerApellido = "";
                        else this.state.datosIdentidad[0].primerApellido = data.primerApellido;
    
                        if(data.segundoApellido === null) this.state.datosIdentidad[0].segundoApellido = "";
                        else this.state.datosIdentidad[0].segundoApellido = data.segundoApellido;
    
                        if(data.tercerApellido === null) this.state.datosIdentidad[0].tercerApellido = "";
                        else this.state.datosIdentidad[0].tercerApellido = data.tercerApellido;
    
                        this.state.datosIdentidad[0].nombreCompletoPrueba = this.state.datosIdentidad[0].primerNombre+' '+ this.state.datosIdentidad[0].segundoNombre+', '+ this.state.datosIdentidad[0].primerApellido+' '+ this.state.datosIdentidad[0].segundoApellido+', '+this.state.datosIdentidad[0].tercerApellido
                        this.state.datosIdentidad[0].nombreCompleto = data.primerNombre+' '+ data.segundoNombre+', '+ data.primerApellido+' '+ data.segundoApellido+', '+data.tercerApellido
                        this.state.datosIdentidad[0].fechaNacimiento = data.fechaNacimiento
                        this.state.datosIdentidad[0].foto = 'data:image/jpeg;base64,'+ response.data.object.fotoCiudadano; this.state.datosIdentidad[0].width = 300; this.state.datosIdentidad[0].height = 400
                        this.state.datosIdentidad[1].foto = 'data:image/jpeg;base64,'+ response.data.object.firmaCiudadano; this.state.datosIdentidad[1].width = 300; this.state.datosIdentidad[1].height = 100
                        this.state.datosIdentidad[2].foto = 'data:image/jpeg;base64,'+ response.data.object.huellaCiudadano; this.state.datosIdentidad[2].width = 300; this.state.datosIdentidad[2].height = 390
                        this.setState({fotosVieneVacio: false, mensajeFotosVieneVacio:'',loadingCargarFotosDeIdentidad:false,});
                    }   
                    this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD(this.state.datosIdentidad)
                    this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
                    this.getUserState(data.datosDpiSolicitudEmpadronamiento.cui)
                    this.setState({idSolicitudObtenido: data.idSolicitud ,abrirModalAceptarSolicitud:true, });
                    this.setState({loadingCargarFotosDeIdentidad: false, accionDeProceso: data.datosSolicitudEmpadronamiento.tipoSolicitud, isNacional: data.datosSolicitudEmpadronamiento.nacionalExtranjero})
                }catch(exception){                
                    this.setState({loadingCargarFotosDeIdentidad: false})
                    if (exception.status===404) {
                        showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                    }
                    else {
                        showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                    }
                }            
            }
        }
        CerrarModalSolicitudEmpadronamientoModal(){ 
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            this.setState({abrirModalAceptarSolicitud:false}); 
        }
    // PORTAL WEB EXTERNO
    // abrimos el modal para procesar o rechazar una solicitud del portal web externo
        AbrirModalProcesarSolicitudPortalWebExterno(data){
            // vacios
            this.props.SET_RESIDENCIA_ACTUAL_PADRON({})
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')

            // al seleccionar un homonimo este debe de ser seteado con el nuevo cui
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB(data.datosDpiSolicitudEmpadronamiento.cui)
            this.setState({idSolicitudObtenido: data.idSolicitud , cuiDPI: data.datosDpiSolicitudEmpadronamiento.cui })
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB(data)
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
            this.setState({accionDeProceso: data.datosSolicitudEmpadronamiento.tipoSolicitud, isNacional: data.datosSolicitudEmpadronamiento.nacionalExtranjero, abrirModalSolicitudDelPortalWebTSE: true})

            const filters = {
                municipioNacio :"0",
                departamentoNacio : "0",
                fechaNacio : functions.dateFormatGeneral(data.fechaNacimiento),
                nom1 : data.primerNombre,
                nom2 : data?.segundoNombre ? data?.segundoNombre : "",
                ape1 : data.primerApellido,
                ape2 : data?.segundoApellido ? data?.segundoApellido : "",
                cui: '',
                ordenCedula : '',
                registroCedula: ''
                // genero: "",
                // fechaNacio : "",
            }
            try {
                this.props.SET_DATOS_GENERALES_DEL_CIUDADANO({...this.state.datosGeneralesDelCiudadano, nom1: data.primerNombre, nom2: data?.segundoNombre,  ape1: data.primerApellido, ape2: data?.segundoApellido, fechaNacimiento: data.fechaNacimiento});
                this.setState({arrayHomonimos: []})
                ApiServices.verificarHomonimos.initSearchCriteria.clear();
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("municipioNacio", filters.municipioNacio);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("departamentoNacio", filters.departamentoNacio);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("fechaNacio", filters.fechaNacio);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("nom1", filters.nom1);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("nom2", filters.nom2);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("ape1", filters.ape1);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("ape2", filters.ape2);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("cui", filters.cui);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("ordenCedula", filters.ordenCedula);
                ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                ApiServices.verificarHomonimos.initSearchCriteria.addEquals("registroCedula", filters.registroCedula);

            } catch (error) {

            }

            // console.log("Finalizamos la funcion abrir portal web");
        }

        CerrarModalProcesarSolicitudPortalWebExterno(){
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            this.setState({abrirModalSolicitudDelPortalWebTSE: false})
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB(0)
        }
    // MODAL PORTAL WEB SOLICITUD DE EXTRANJERO
    //abrimos el modal para procesar la solicitud de extranjero Y NACIONAL DE DELEGACIONES
        AbrirModalProcesarSolicitudExtranjero(data){ 
            if(data?.idSolicitud){
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
                this.setState({idSolicitudObtenido: data.idSolicitud , datosSolicitudExtranjero: data})
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD([])                
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP(data.datosSolicitudEmpadronamiento.idSolicitud)
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI(data.datosDpiSolicitudEmpadronamiento?.cui) 
                this.setState({modalProcesarSolicitudExtranjero:true, accionDeProceso: data.datosSolicitudEmpadronamiento.tipoOrigen +' / NUEVA '+data.datosSolicitudEmpadronamiento.tipoSolicitud, isNacional: data.datosSolicitudEmpadronamiento.nacionalExtranjero});

                // const filters = {
                //     municipioNacio :"0",
                //     departamentoNacio : "0",
                //     fechaNacio : functions.dateFormatGeneral(data.fechaNacimiento),
                //     nom1 : data.primerNombre,
                //     nom2 : data?.segundoNombre ? data?.segundoNombre : "",
                //     ape1 : data.primerApellido,
                //     ape2 : data?.segundoApellido ? data?.segundoApellido : "",
                //     cui: '',
                //     ordenCedula : '',
                //     registroCedula: ''
                //     // genero: "",
                //     // fechaNacio : "",
                // }
                // try {
                //     this.props.SET_DATOS_GENERALES_DEL_CIUDADANO({...this.state.datosGeneralesDelCiudadano, nom1: data.primerNombre, nom2: data?.segundoNombre,  ape1: data.primerApellido, ape2: data?.segundoApellido, fechaNacimiento: data.fechaNacimiento});
                //     this.setState({arrayHomonimos: []})
                //     ApiServices.verificarHomonimos.initSearchCriteria.clear();
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("municipioNacio", filters.municipioNacio);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("departamentoNacio", filters.departamentoNacio);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("fechaNacio", filters.fechaNacio);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("nom1", filters.nom1);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("nom2", filters.nom2);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("ape1", filters.ape1);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("ape2", filters.ape2);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("cui", filters.cui);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("ordenCedula", filters.ordenCedula);
                //     ApiServices.verificarHomonimos.initSearchCriteria.setOperator("and");
                //     ApiServices.verificarHomonimos.initSearchCriteria.addEquals("registroCedula", filters.registroCedula);
                // } catch (error) {

                // }
            }
        }
        CerrarModalProcesarSolicitudExtranjero(){
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            this.setState({modalProcesarSolicitudExtranjero:false});
        }
    //abrimos el modal para rechazar solicitudes de empadronamiento
        async AbrirModalRechazarSolicitudEmpadronamientoModa(data){ 
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
            this.setState({loadingCargarFotosDeIdentidad: true})
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD([])                
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP(data.datosSolicitudEmpadronamiento.idSolicitud)
            // this.setState({abrirModalRechazoSolicitud:true, });                               
            try{
                const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(data.datosDpiSolicitudEmpadronamiento.cui);
                if(data.primerNombre === null) this.state.datosIdentidad[0].primerNombre = "";
                else this.state.datosIdentidad[0].primerNombre = data.primerNombre;

                if(data.segundoNombre === null) this.state.datosIdentidad[0].segundoNombre = "";
                else this.state.datosIdentidad[0].segundoNombre = data.segundoNombre;

                if(data.primerApellido === null) this.state.datosIdentidad[0].primerApellido = "";
                else this.state.datosIdentidad[0].primerApellido = data.primerApellido;

                if(data.segundoApellido === null) this.state.datosIdentidad[0].segundoApellido = "";
                else this.state.datosIdentidad[0].segundoApellido = data.segundoApellido;

                if(data.tercerApellido === null) this.state.datosIdentidad[0].tercerApellido = "";
                else this.state.datosIdentidad[0].tercerApellido = data.tercerApellido;                
                // const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad('3280804031101');
                this.state.datosIdentidad[0].nombreCompletoPrueba = this.state.datosIdentidad[0].primerNombre+' '+ this.state.datosIdentidad[0].segundoNombre+', '+ this.state.datosIdentidad[0].primerApellido+' '+ this.state.datosIdentidad[0].segundoApellido+', '+this.state.datosIdentidad[0].tercerApellido
                this.state.datosIdentidad[0].nombreCompleto = data.primerNombre+' '+ data.segundoNombre+', '+ data.primerApellido+' '+ data.segundoApellido+', '+data.tercerApellido
                this.state.datosIdentidad[0].fechaNacimiento = data.fechaNacimiento
                if(response.error!==null){
                    this.state.datosIdentidad[0].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[0].width = 480; this.state.datosIdentidad[0].height = 640
                    this.state.datosIdentidad[1].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[1].width = 480; this.state.datosIdentidad[1].height = 640
                    this.state.datosIdentidad[2].foto = "/assets/noImagen.svg"; this.state.datosIdentidad[2].width = 480; this.state.datosIdentidad[2].height = 640
                    this.setState({abrirModalRechazoSolicitud:true, fotosVieneVacio: true, mensajeFotosVieneVacio: response.error.message, loadingCargarFotosDeIdentidad:false,});
                }else{                
                    this.state.datosIdentidad[0].foto = 'data:image/jpeg;base64,'+ response.data.object.fotoCiudadano; this.state.datosIdentidad[0].width = 480; this.state.datosIdentidad[0].height = 640
                    this.state.datosIdentidad[1].foto = 'data:image/jpeg;base64,'+ response.data.object.firmaCiudadano; this.state.datosIdentidad[1].width = 300; this.state.datosIdentidad[1].height = 100
                    this.state.datosIdentidad[2].foto = 'data:image/jpeg;base64,'+ response.data.object.huellaCiudadano; this.state.datosIdentidad[2].width = 416; this.state.datosIdentidad[2].height = 416
                    this.setState({abrirModalRechazoSolicitud:true, fotosVieneVacio: false, mensajeFotosVieneVacio:'',loadingCargarFotosDeIdentidad:false,});
                }   
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD(this.state.datosIdentidad)
            }catch(exception){
                this.setState({loadingCargarFotosDeIdentidad:false})
                if (exception.status===404) {
                    showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }
                else {
                    showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }
            }            
        }
        async CerrarModalRechazoDeSolicitudEmpadronamientoModal(){ 
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            // if(this.props.esRechazadoOEmpadronado===true){
            //     console.log('saveData 111')
            //     this.showList();                 
            // }
            this.setState({abrirModalRechazoSolicitud:false});
        }
        // cargamos todas las solicitudes
        // obtenerDatosDeLaTabla(data){
        //     // PROCESO NACIONAL PARA PROCESAR LA SOLICITUD DE FORMA AUTOMATICA
        //     if(this.props.idSolicitudGeneradoNacional){
        //         this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
        //         this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
        //         this.AbrirModalProcesarSolicitudExtranjero(data[0]);
        //     }
        // }
        FuncionBuscarCuiEnLaTabla (){

        }
        async showList(){
            try{
                this.setState({loading: true, checkAutorization: false});
                const hasPermission = await ApiServices.userSecurity.hasPermission('solicitudesDeEmpadronamiento','list');    
                if (hasPermission.error){
                    this.setState({checkAutorization: false,authorized: false,loading: false });
                }else{
                    ApiServices[this.state.controller].initSearchCriteria.clear();
                    // ApiServices[this.state.controller].orderCriteria.addDesc("fechaSolicitud");
                    ApiServices[this.state.controller].initSearchCriteria.setOperator("and");
                    ApiServices[this.state.controller].initSearchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud", 0);  
                    ApiServices[this.state.controller].initSearchCriteria.NotEquals("datosSolicitudEmpadronamiento.nombreOrigen", 4);  
                    // ApiServices[this.state.controller].initSearchCriteria.addEquals("datosDpiSolicitudEmpadronamiento.cui", 3995890822202);
                    ApiServices[this.state.controller].initOrderCriteria.clear();
                    ApiServices[this.state.controller].initOrderCriteria.addDesc("datosSolicitudEmpadronamiento.idSolicitud");

                    // if(this.props.idSolicitudGeneradoNacional) {
                    //     ApiServices[this.state.controller].initSearchCriteria.addContains("idSolicitud", this.props.idSolicitudGeneradoNacional);                      
                    //     ApiServices[this.state.controller].initSearchCriteria.addContains("datosDpiSolicitudEmpadronamiento.cui", this.props.datosSolicitudGeneradoNancional?.cui);                      
                    //     ApiServices[this.state.controller].initSearchCriteria.addContains("usuarioCreador", this.props.datosSolicitudGeneradoNancional?.usuario);                      
                    // }
                    this.setState({checkAutorization: true, authorized: true,loading: false,data: [], create: false });
                    this.props.ObtenerTotalDeSolicitudesPendientesDeRealizar()
                }
            }catch(exception){
                showMessagePersonalizedPosition('error', '¡Advertencia! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
                this.setState({ loading: false,checkAutorization: false, data:[]});
            }
        }
        async componentDidMount() {
            if (!this.state.dialogoStatus) {
                this.mostrarInstruccion()
                this.props.SET_DIALOGO_STATUS(true)
            }

            // this.showList();
            this.ObtenerDatosEmpadronador();
             // Diego
            // Ver si la variable "esCitaDeEmpadronamiento" es true en el redux. Si sí, llamar a openModalForNewCensusRegistration().
            // if (this.props.citaEnProceso.idCita !== "" && this.props.citaEnProceso.cuiCiudadano !== ""){
            //     this.openModalForNewCensusRegistration();
            // }
        }
        // componentDidUpdate() {
        //     if(this.props.esRechazadoOEmpadronado){
        //         console.log('saveData 222')
        //         this.showList(); 
        //         this.props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
        //     }
        // }    

      //abrimos el modal para aprobar solicitudes de empadronamiento
    async openModalForNewCensusRegistration(){ 
        this.props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(0);
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO({cui: '', usuario: ''})
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION('Nuevo Empadronamiento o Actualización de datos')
        this.setState({showModalNewCensusRegistration : true});
    }
    async closeModalForNewCensusRegistration(){ 
        // this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO({cui: '', usuario: ''})
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
        this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
        this.props.SET_DATA_IS_REGISTERED({})
        this.props.CLEAR_DATA_DATOS_IDENTIDAD();  
        this.props.CLEAR_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO();
        this.props.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(0);
        
        this.setState({showModalNewCensusRegistration : false});
        // Limpiando la cita en proceso para que al abrir nuevamente el modal,
        // ya no se abra con la información del ciudadano cuya cita estabamos atendiendo.
        if (this.props.citaEnProceso.idCita !== "" && this.props.citaEnProceso.cleanRegisterOnExit === true) {
          this.props.CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO(
            this.props.citaEnProcesoVacia
          );
        }
    }
    async getUserState (cui){
        this.setState({loading: true});
        try {
            let response = await ApiServices.solicitudesDeEmpadronamiento.validarEmpadronado(cui)
            if(response.error!==null){
                this.setState({estaEmpadronado: false, nroBoleta: ''});
            }else{
                this.setState({estaEmpadronado: true, nroBoleta: response.data.numeroBoleta});
            }  
        } catch (exception) {
            if(exception.status===404) {
                showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }else {
                showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
            }
            this.setState({ loading: false});
        }
        this.setState({loading: false});
    }
    obtenerPaginacionTabla (datosTabla){
        // console.log("obtenerPaginacionTabla", datosTabla);
        this.paginacionTable = datosTabla
        this.pageSize = datosTabla.pageSize
    }
    async descargarReporteSolicitudesNuevas(){
        try {
            ApiServices.solicitudesDeEmpadronamiento.searchCriteria.clear();
            ApiServices.solicitudesDeEmpadronamiento.searchCriteria.setOperator("and");
            ApiServices.solicitudesDeEmpadronamiento.searchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud", 0);       
            let response = await ApiServices.solicitudesDeEmpadronamiento.exportarExcel(this.paginacionTable)
            if(response.error!==null){
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
            }else{
                const fileName = "Reporte de solicitudes.xlsx";
                functions.downloadPDFFromStringBase64( response.data, fileName);                
                showMessagePersonalizedPosition('success','Bien!', 'Reporte descargado con éxito','center')
            }  
        } catch (exception) {
            if(exception.status===404) {
                showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }else {
                showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
            }            
        }
    }
    async AbrirMostrarPDFModal(data){
        this.setState({loading: true});
        try {
            let saveData = {cui: data.datosDpiSolicitudEmpadronamiento.cui, nroSolicitudRenap: data.datosSolicitudEmpadronamiento.nroSolicitudRenap}
            ApiServices.solicitudesDeEmpadronamiento.initOrderCriteria.clear();
            let response = await ApiServices.solicitudesDeEmpadronamiento.descargarPdfSolicitudDeRenap(saveData)
            if(response.error!==null){
                showMessagePersonalizedPosition('warning','¡Oops! ',response.error.message,'center')
            }
            else{
                if(response.data.base64 ==='') showMessagePersonalizedPosition('warning','¡Oops! ','Ciudadano(a) '+data.nombreCompleto+' no cuenta con Hoja de Autorización de RENAP','center');
                else this.setState({base64PDFHojaAutorizacionRenap: response.data.base64, abrirMostrarPDFModal: true});
            }
        } catch (exception) {
            if(exception.status===404) {
                showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
            }else {
                showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
            }
        }
        this.setState({loading: false});
    }
    CerrarMostrarPDFModal(){
        this.setState({abrirMostrarPDFModal:false})
    }

    CerrarMostrarPDFModal(){
        this.setState({abrirMostrarPDFModal:false})
    }

    mostrarInstruccion (){
        this.setState({openDialogInstruction:true})
    }

    cerrarMostrarInstruccion (){
        this.setState({openDialogInstruction:false})
    }
    render() {
        // if (this.state.checkAutorization ) return <LoadingSpinner open={this.state.loading}/>
        // if (!this.state.authorized &&  !this.state.loading){ return <NotAuthorized/>}
        return (
            <div >
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}
                {/* <div>
                    <span>.</span>
                </div> */}
                <ModalInformation 
                    open={this.state.openDialogInstruction}
                    showButton={true}
                    handleClose={this.cerrarMostrarInstruccion}
                />

                <LoadingSpinner open={this.state.loadingCargarFotosDeIdentidad}/>
                <LoadingSpinner open={this.loadingDescargarReporte}/>

                <CrearSolicitud     
                    open={this.state.abrirModalAceptarSolicitud}   
                    controller={this.state.controller}
                    actualizarTabla={this.showList}
                    usuarioEstaEmpadronado={this.state.estaEmpadronado}
                    nroBoleta={this.state.nroBoleta}
                    accionDeProceso={this.state.accionDeProceso}
                    isNacional={this.state.isNacional}
                    idSolicitudObtenido={this.state.idSolicitudObtenido}
                    // handleClose={this.showList} />
                    fotosVieneVacio={this.state.fotosVieneVacio}
                    mensajeFotosVieneVacio={this.state.mensajeFotosVieneVacio}
                    ObtenerTotalDeSolicitudesPendientesDeRealizar={this.props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                    handleClose={this.CerrarModalSolicitudEmpadronamientoModal} 
                    datosResidenciaExtranjeroRenapSeleccionado={this.state.datosResidenciaExtranjeroRenapSeleccionado}
                />
                <RechazarSolicitud  open={this.state.abrirModalRechazoSolicitud}   
                                    controller={this.state.controller}
                                    fotosVieneVacio={this.state.fotosVieneVacio}
                                    mensajeFotosVieneVacio={this.state.mensajeFotosVieneVacio}
                                    // handleClose={this.showList} />
                                    actualizarTabla={this.showList}
                                    handleClose={this.CerrarModalRechazoDeSolicitudEmpadronamientoModal} />

                {/* <NewCensusRegistration
                    open={this.state.showModalNewCensusRegistration}   
                    controller={this.state.controller}
                    handleClose={this.closeModalForNewCensusRegistration}
                /> */}
                {this.state.showModalNewCensusRegistration && (
                    <SolicitudesEmpadronamiento
                        actualizarTabla={this.showList}
                        open={this.state.showModalNewCensusRegistration}   
                        controller={this.state.controller}
                        handleClose={this.closeModalForNewCensusRegistration}
                        citaEnProceso={this.props.citaEnProceso}
                        // ObtenerTotalDeSolicitudesPendientesDeRealizar={this.props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                        AbrirModalProcesarSolicitudExtranjero={this.AbrirModalProcesarSolicitudExtranjero}
                        ejecutar={true}
                    />
                )}
                {this.state.modalProcesarSolicitudExtranjero && (
                    <SolicitudesExtranjero
                        idSolicitudObtenido={this.state.idSolicitudObtenido}
                        datosSolicitudExtranjero={this.state.datosSolicitudExtranjero}
                        actualizarTabla={this.showList}
                        arrayHomonimos={this.state.arrayHomonimos}
                        open={this.state.modalProcesarSolicitudExtranjero}   
                        handleClose={this.CerrarModalProcesarSolicitudExtranjero}
                        accionDeProceso={this.state.accionDeProceso}
                        isNacional={this.state.isNacional}
                        ObtenerTotalDeSolicitudesPendientesDeRealizar={this.props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                    />
                )}

                {/* componentes para procesar y rechazar solicitudes del portal web externo */}
                {this.state.abrirModalSolicitudDelPortalWebTSE && (
                    <ProcesarSolicitudDelPortalWebTSE
                                        cuiDPI={this.state.cuiDPI}
                                        arrayHomonimos={this.state.arrayHomonimos}
                                        controller={this.state.controller}
                                        actualizarTabla={this.showList}
                                        // handleClose={this.showList} />
                                        // fotosVieneVacio={this.state.fotosVieneVacio}
                                        // mensajeFotosVieneVacio={this.state.mensajeFotosVieneVacio}
                                        open={this.state.abrirModalSolicitudDelPortalWebTSE}   
                                        accionDeProceso={this.state.accionDeProceso}
                                        isNacional={this.state.isNacional}
                                        handleClose={this.CerrarModalProcesarSolicitudPortalWebExterno} />
                )}
                {/* <RechazarSolicitud  open={this.state.abrirModalRechazoSolicitud}   
                                    controller={this.state.controller}
                                    fotosVieneVacio={this.state.fotosVieneVacio}
                                    mensajeFotosVieneVacio={this.state.mensajeFotosVieneVacio}
                                    // handleClose={this.showList} />
                                    handleClose={this.CerrarModalRechazoDeSolicitudEmpadronamientoModal} /> */}
                                   
                <ComponenteToolbar
                    titleGeneral={''}
                    buttonTitleUpdate={"Actualizar tabla"}
                    buttonIconUpdate={<RestorePage/>}
                    buttonFunctionUpdate= {this.showList}
                    buttonTitleCreate={"Crear Solicitud"}
                    buttonIconCreate={<Add/>}
                    buttonFunctionCreate= {this.openModalForNewCensusRegistration}
                    buttonTitleReport={"Descargar Reporte"}
                    buttonIconReport={<GetApp/>}
                    buttonFunctionReport= {this.descargarReporteSolicitudesNuevas}
                />
                {
                    (this.state.checkAutorization) ? (
                        <Table  
                                title={"Listado de solicitudes nuevas"}
                                header = {this.state.header}
                                service={ApiServices[this.state.controller]}
                                // refreshList={this.showList}
                                pageSize={this.pageSize}
                                detailPanel={this.state.detailPanel}
                                data={[]} 
                                showToolbar={false}
                                showSearcher={false}
                                showFilterGeneral={false}
                                showFilter={true}
                                // searchList={[un array del header personalizado]}
                                // addRegister={this.openModalForNewCensusRegistration} 
                                // nameToolTipAdd="Crear solicitud"
                                // reportNewRequests={this.descargarReporteSolicitudesNuevas} 
                                // nameToolTipReportNewRequests="Descargar Reporte"
                                // idSolicitudGeneradoNacional={this.props.idSolicitudGeneradoNacional}
                                // obtenerDatos={true}
                                obtenerPaginacionTabla={this.obtenerPaginacionTabla}
                                FuncionObtenerDatosGeneralesDeLaTabla={this.FuncionObtenerDatosGeneralesDeLaTabla}
                        />
                    ) : ''
                 }
                <MostrarPDFModal open={this.state.abrirMostrarPDFModal} handleClose={this.CerrarMostrarPDFModal} 
                    title={'Hoja de autorización del ciudadano(a)'}
                    base64={this.state.base64PDFHojaAutorizacionRenap}
                />
                {
                    (this.props.idSoliciutudDelegacionProcesado?.open) && (
                        <DescargarConstanciaEmpadronamiento />
                    )
                }
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesNuevas);